import favorites from './favorites'
import user from './user'
import orders from './orders'

export { orders, user, favorites }



// WEBPACK FOOTER //
// ./src/features/Personal/reducers/index.js